if (!customElements.get('shipping-protect-toggle')) {
  customElements.define(
    'shipping-protect-toggle',
    class ShippingProtectToggle extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.shipping-protect__input');
        this.input.addEventListener('change', () => this.update(this.input.checked));

        // Cart only holds the add-on once the real items are gone: drop it.
        if (this.dataset.onlyProtect === 'true') this.update(false);
      }

      async update(add) {
        const drawer = this.closest('cart-drawer');
        const variantId = Number(this.dataset.variantId);
        const body = {
          sections: drawer.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname,
        };

        this.input.disabled = true;
        try {
          const response = await fetch(add ? routes.cart_add_url : routes.cart_change_url, {
            ...fetchConfig(),
            body: JSON.stringify(
              add ? { ...body, items: [{ id: variantId, quantity: 1 }] } : { ...body, id: String(variantId), quantity: 0 }
            ),
          });
          const state = await response.json();
          if (!response.ok || state.status || !state.sections) throw new Error(state.description || 'Cart update failed');

          drawer.renderContents({ id: variantId, sections: state.sections });
        } catch (error) {
          console.error(error);
          this.input.checked = !add;
          this.input.disabled = false;
        }
      }
    }
  );
}
